import LineSearchIcon from 'LuxKit/Icons/line/LineSearchIcon'
import useCurrentGlobalSearchVerticalPage from 'hooks/GlobalSearch/useCurrentGlobalSearchVerticalPage'
import useGlobalSearchURLHashVertical from 'hooks/GlobalSearch/useGlobalSearchURLHashVertical'
import useGlobalSearchVerticalTabs from 'hooks/GlobalSearch/useGlobalSearchVerticalTabs'
import { memo, useCallback } from 'react'
import styled from 'styled-components'
import NavBarButton from '../NavBarButton/NavBarButton'
import { mediaQueryUp } from 'components/utils/breakpoint'
import useNavBarShowsMobileSearchIcon from 'hooks/Navigation/useNavBarShowsMobileSearchIcon'

const IconSearchInput = styled(NavBarButton)`
  ${mediaQueryUp.tablet} {
    display: none;
  }
`

interface Props {
  className?: string
}

function NavBarSearchButton(props: Props) {
  const { className } = props
  const globalSearchVerticalTabs = useGlobalSearchVerticalTabs()
  const currentSearchVerticalPage = useCurrentGlobalSearchVerticalPage()
  const { toggleSearchVertical } = useGlobalSearchURLHashVertical()
  const showsMobileSearchIcon = useNavBarShowsMobileSearchIcon()

  const onSearchClick = useCallback(() => {
    const verticalTab = currentSearchVerticalPage ?? globalSearchVerticalTabs.keys().next().value
    toggleSearchVertical(verticalTab)
  }, [currentSearchVerticalPage, globalSearchVerticalTabs, toggleSearchVertical])

  if (!showsMobileSearchIcon) {
    return null
  }

  return <IconSearchInput
    className={className}
    icon={<LineSearchIcon />}
    onClick={onSearchClick}
  />
}

export default memo(NavBarSearchButton)
